module.exports = __webpack_public_path__ + "static/img/008.fe975fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/008.png
// module id = xLVC
// module chunks = 1